import { apiClient } from "../api";
import { CreateTeamMemberDto, UpdateTeamMemberDto, TeamMember } from "../generated/client";

export const createTeamMember = async (data: CreateTeamMemberDto): Promise<TeamMember> => {
    try {
        const response = await apiClient.team.create(data);
        return response.data;
    } catch (error) {
        console.error("create team member:", error);
        throw error;
    }
};

export const getAllTeamMembers = async (): Promise<TeamMember[]> => {
    try {
        const response = await apiClient.team.findAll();
        return response.data;
    } catch (error) {
        console.error("fetch team members:", error);
        throw error;
    }
};

export const getTeamMemberById = async (id: string): Promise<TeamMember> => {
    try {
        const response = await apiClient.team.findOne(id);
        return response.data;
    } catch (error) {
        console.error(`fetch team member by ID ${id}:`, error);
        throw error;
    }
};

export const updateTeamMember = async (id: string, data: UpdateTeamMemberDto): Promise<TeamMember> => {
    try {
        const response = await apiClient.team.update(id, data);
        return response.data;
    } catch (error) {
        console.error(`update team member by ID ${id}:`, error);
        throw error;
    }
};

export const removeTeamMember = async (id: string): Promise<TeamMember> => {
    try {
        const response = await apiClient.team.remove(id);
        return response.data;
    } catch (error) {
        console.error(`removing team member by ID ${id}:`, error);
        throw error;
    }
};
